import { EmergencyCall } from "./incident.types";

export enum ContactOption {
  CALL = "CALL",
  EMAIL = "EMAIL",
  MESSAGE = "MESSAGE",
  /**
   * All contacts or contactGroups
   */
  ALL = "ALL",
}

export enum ContactOptionGerman {
  CALL = "Anruf",
  EMAIL = "Email",
  MESSAGE = "SMS",
}

export type Scenario = {
  id: string;
  userId: string;
  title: string;
  emergencyCall: EmergencyCall;
  contactGroupSettings?: Map<ContactOption, string[]>;
  contactSettings?: Map<ContactOption, string[]>;
  incidentDetails: string;
  contactDeviceContacts?: boolean;
  color?: string;
  icon?: string;
};

export type FSScenario = Omit<
  Scenario,
  "contactGroupSettings" | "contactSettings"
> & {
  contactGroupSettings?: Record<ContactOption, string[]>;
  contactSettings?: Record<ContactOption, string[]>;
};
